import { CustomSettingGuard } from '@components/customSettingGuard';
import { ProtectedRoute } from '@components/protectedRoute';
import { appRoutes } from '@utils/consts';
import { parseRoute } from '@utils/i18n';

export const onDeckRoutes = [
  {
    path: appRoutes.onDeck,
    lazy: async () => {
      const { HotSeat } = await import('@pages/hotSeat');
      const { HotSeatProvider } = await import('@contexts/hotSeat');
      return {
        Component: () => (
          <ProtectedRoute>
            <CustomSettingGuard
              disabledBy="on_deck_view_disabled"
              redirectTo={parseRoute(appRoutes.index)}>
              <HotSeatProvider>
                <HotSeat onDeck />
              </HotSeatProvider>
            </CustomSettingGuard>
          </ProtectedRoute>
        ),
      };
    },
  },
];
